import { signal } from "alien-signals";

export function getFilename(url) {
  const pathname = new URL(url, window.location.href).pathname;
  const index = pathname.lastIndexOf("/");
  const filename = index !== -1 ? pathname.substring(index + 1) : pathname;
  return filename;
}

/**
 * fetch() that treats a non-2xx response as a failure and retries up to
 * `attempts` more times, waiting `backoffMs`, then twice that, and so on.
 */
export const fetchRetry = async (
  url,
  options = {},
  attempts = 0,
  backoffMs = 0,
) => {
  try {
    const res = await window.fetch(url, options);
    if (res.ok) {
      return res;
    } else {
      throw new Error(`Fetch Response not OK: ${res.status}`);
    }
  } catch (err) {
    if (attempts <= 0) {
      throw err;
    }
    if (backoffMs > 0) {
      await new Promise((resolve) => setTimeout(resolve, backoffMs));
    }
    return await fetchRetry(url, options, attempts - 1, backoffMs * 2);
  }
};

export const fetchSignal = signal(fetchRetry);

export function generateNonce(length = 11) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  array = array.map((x) => chars.charCodeAt(x % chars.length));
  return String.fromCharCode.apply(null, array);
}
